export default __webpack_public_path__ + "static/media/vps-remote-desktop-windows.5b287bef.png";